import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 2C45.9 2 2 45.9 2 100s43.9 98 98 98 98-43.9 98-98-43.9-98-98-98zm44.1 104.3-37.8 37.8c-3.5 3.5-9.1 3.5-12.6 0l-37.8-37.8c-3.5-3.5-3.5-9.1 0-12.6l37.8-37.8c3.5-3.5 9.1-3.5 12.6 0l37.8 37.8c3.5 3.5 3.5 9.1 0 12.6z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}